import { useEffect, useState } from "react";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { FaWhatsapp } from "react-icons/fa";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useGetformMutation } from "../slices/formApiSlice";
import { parseUserInfo } from "../utils/parseUtil";

const HomeScreen = () => {
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [language, setLanguage] = useState("0");
  const [showModal, setShowModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [ph, setPh] = useState("");
  const [yearsOptions, setYearsOptions] = useState([]);

  const { userInfo } = useSelector((state) => state.auth);
  const [getForm, { isLoading }] = useGetformMutation();

  useEffect(() => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1;

    const previousMonth = currentMonth === 1 ? 12 : currentMonth - 1;

    const startYear = parseInt(process.env.REACT_APP_START_YEAR, 10 || 2020);

    const options = [];
    for (let i = startYear; i <= currentYear + 1; i++) {
      options.push(i);
    }

    setYearsOptions(options);
    setYear(currentYear.toString());
    setMonth(previousMonth.toString());
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const reqCompanyCode = userInfo[13]?.InfoField;
    const reqEmpCode = userInfo[1]?.InfoField;

    const formData = new FormData();
    formData.append("title", "GetSalarySlipForEmployee");
    formData.append("description", "GetStaffDetails");
    formData.append("ReqYear", year);
    formData.append("ReqEmpCode", reqEmpCode);
    formData.append("ReqCompanyCode", reqCompanyCode);
    formData.append("ReqSlipType", language);
    formData.append("ReqMonth", month);

    // if (month) {
    //   formData.append('ReqMonth', month)
    // } else {
    //   formData.append('ReqRptType', '0')
    // }

    // Log formData contents
    // for (let [key, value] of formData.entries()) {
    //   console.log(`${key}: ${value}`,"Salary Slip")
    // }

    try {
      const res = await getForm(formData);

      const parsedData = parseUserInfo(res);

      if (parsedData && Array.isArray(parsedData) && parsedData.length > 0) {
        const data = parsedData[0];

        if (data.ErrorCode === "0") {
          let pdfPath = data.JSONData1;

          if (pdfPath.startsWith("/api/WebServiceForStaffData.aspx/")) {
            pdfPath = pdfPath.replace("/api/WebServiceForStaffData.aspx/", "/");
          }

          const backendUrl = process.env.REACT_APP_URL;
          const pdfUrl = `${backendUrl}${pdfPath}`;

          setPdfUrl(pdfUrl);
          setShowModal(true);
        } else {
          toast.error(data.ErrorMessage || "An error occurred");
        }
      } else {
        toast.error("Failed to parse user info");
      }
    } catch (err) {
      console.error("Error submitting data:", err);
      toast.error(err?.data?.message || "Error submitting data");
    }
  };

  const handleSendToWhatsApp = () => {
    const message = `Here’s the PDF you requested: ${pdfUrl}`;
    const phoneNumber = ph;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(whatsappUrl, "_blank");
  };

  return (
    <Container className="form-container mt-5">
      <h4 className="mt-4 text-center">Print Salary Slip</h4>
      <Form className="border p-4 rounded bg-light" onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="month">
              <Form.Label>Month</Form.Label>
              <Form.Control as="select" value={month} onChange={(e) => setMonth(e.target.value)} className="form-control-hover">
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </Form.Control>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="year">
              <Form.Label>Year</Form.Label>
              <Form.Control as="select" value={year} onChange={(e) => setYear(e.target.value)} className="form-control-hover" required>
                {yearsOptions.map((yr) => (
                  <option key={yr} value={yr}>
                    {yr}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col className="radio-box">
            <Form.Group>
              <Form.Label>
                <div className="headline">Language</div>
              </Form.Label>
              <div className="d-flex">
                <Form.Check
                  type="radio"
                  id="english"
                  name="language"
                  label="English"
                  value="0"
                  checked={language === "0"}
                  onChange={(e) => setLanguage(e.target.value)}
                  className="mx-3"
                />
                <Form.Check
                  type="radio"
                  id="hindi"
                  name="language"
                  label="Hindi"
                  value="1"
                  checked={language === "1"}
                  onChange={(e) => setLanguage(e.target.value)}
                />
              </div>
            </Form.Group>
          </Col>
          <Col>
            <Button variant="primary" type="submit" className="mt-3 px-5">
              Print
            </Button>
          </Col>
        </Row>
      </Form>
      <Modal show={showModal} onHide={() => setShowModal(false)} size="xl">
        <Modal.Header closeButton>
          Print Salary Slip
          <Form.Group controlId="ph" className="mb-3 ms-auto">
            <Form.Control
              type="text"
              placeholder="Phone Number"
              value={ph}
              onChange={(e) => setPh(e.target.value)}
              required
              className="form-control-hover"
            />
          </Form.Group>
          <div className="ms-auto">
            <Button variant="success" onClick={handleSendToWhatsApp}>
              <FaWhatsapp style={{ marginRight: "8px" }} />
              Send to WhatsApp
            </Button>
          </div>
        </Modal.Header>
        <Modal.Body>{pdfUrl && <iframe src={pdfUrl} style={{ width: "100%", height: "500px" }} title="PDF Viewer" />}</Modal.Body>
      </Modal>
    </Container>
  );
};

export default HomeScreen;
